import { render, staticRenderFns } from "./feed-upload.vue?vue&type=template&id=651d3db3&scoped=true&"
import script from "./feed-upload.vue?vue&type=script&lang=js&"
export * from "./feed-upload.vue?vue&type=script&lang=js&"
import style0 from "./feed-upload.vue?vue&type=style&index=0&id=651d3db3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d3db3",
  null
  
)

export default component.exports